<template>
    <div class="content page-4">
        <!-- Failed and we are currently not loading -->
        <div v-if="$store.state.bookingFailed && !$store.state.isReservingBooking && !$store.state.bookingSubmitted">
            <section class="section-order section-white">
                <h2 class="text-green">Kunne ikke booke reise.</h2>
                <h3>Kunne ikke booke, kontakt vår support på telefon <a href="tel:90166999">90166999</a> eller på e-post
                    <a
                            href="mailto:info@vitusreiser.no">info@vitusreiser.no</a></h3>
            </section>
        </div>

        <!-- We are currently submitting data, aka waiting for response -->
        <div v-if="$store.state.isReservingBooking">
            <section class="section-order section-white">
                <h2 class="text-green">Vennligst vent:</h2>
                <h3>Vi sender nå valgene dine til booking systemet, du vil bli videresendt til betalingssiden om
                    litt.</h3>
                <img class="chekout-loading" src="/assets/icons/loading.svg" style="width: 200px; margin: auto;">
            </section>
        </div>

        <!-- Shown when done submitting data successfully -->
        <div v-if="!$store.state.isReservingBooking && $store.state.bookingSubmitted">
            <section class="section-order section-white">
                <h2 class="text-green">Du blir snart videresendt til betaling</h2>
                <h3>Vi sender deg nå til betalingssiden, vennligst vent.</h3>
                <img class="chekout-loading" src="/assets/icons/loading.svg" style="width: 200px; margin: auto;">
            </section>
        </div>

        <!-- We have not started submissions yet, there has not yet been a failure -->
        <div v-if="!$store.state.bookingSubmitted && !$store.state.isReservingBooking">
            <div>
                <section class="section-order section-white">
                    <h2 class="text-green">Bekreft:</h2>
                    <h3>
                        Totalpris: {{ $store.getters.totalPrice | nok }}
                    </h3>
                    <hr>
                    <div>
                        <h3>Samtykke til våre vilkår: <span>*</span></h3>
                        <div class="checkbox">
                            <label>
                                <input type="checkbox" v-model="agreedToTermsOfService">
                                <span></span>
                                <span>Jeg bekrefter at jeg har gitt samtykke til at alle ovenforstående opplysninger kan gis videre og brukes av alle relevante leverandører og
                                    partnere i
                                    forbindelse med den bestilte reisen. Jeg bekrefter også at jeg har fullmakt til å gi dette samtykket på vegne av eventuelle øvrige
                                    reisedeltagere. Jeg
                                    bekrefter at jeg har lest og aksepterer <a href="/privatlivspolitikk"
                                                                               target="_blank">Vitusreisers personvernpolitikk</a> og <a
                                            href="/reisebetingelser" target="_blank">generelle reise-, betalings- og avbestillingsvilkår</a>.</span>
                            </label>
                            <div></div>
                            <br>
                            <div class="input-error"
                                 v-if="!$v.agreedToTermsOfService.mustBetrue && $v.agreedToTermsOfService.$dirty">
                                Du må godkjenne vilkårene for å gå videre.
                            </div>
                        </div>
                    </div>

                    <div>
                        <h3>Ønske om å motta informasjon:</h3>
                        <div class="checkbox">
                            <label>
                                <input type="checkbox" v-model="agreedToMarketing">
                                <span></span>
                                <span>
                                    JA, jeg ønsker å motta informasjon, nyheter og tilbud fra Vitusreiser og få de beste reisetilbudene.
                                </span>
                            </label>
                        </div>
                    </div>
                </section>
                <section class="section-order section-white">
                    <h3>Velg hvordan du vil betale reisen:</h3>
                    <div class="custom-radio">
                        <input id="payment-method-postpone"
                               type="radio"
                               :checked="selectedPaymentMethod === 'postpone'"
                               value="postpone"/>
                        <label for="payment-method-postpone" @click="selectedPaymentMethod = 'postpone'">
                            Jeg vil betale i nettbank med betalingsopplysninger som jeg mottar i
                            reisebekreftelsen (ingen gebyrer). </label>
                    </div>
                    <div class="custom-radio">
                        <input id="payment-method-full"
                               type="radio"
                               :checked="selectedPaymentMethod === 'full'"
                               value="full"/>
                        <label for="payment-method-full" @click="selectedPaymentMethod = 'full'">
                            Jeg betaler hele reisen med betalingskort nå.
                        </label>
                    </div>
                    <div class="custom-radio" v-if="$store.state.bookingData.canPayWithInvoice">
                        <input id="payment-method-deposit"
                               type="radio"
                               :checked="selectedPaymentMethod === 'deposit'"
                               value="deposit"/>
                        <label for="payment-method-deposit" @click="selectedPaymentMethod = 'deposit'">
                            Jeg vil betale kr. {{ depositAmount | nok }} i depositum med betalingskort nå og resten i
                            nettbank eller med betalingskort senere.
                        </label>
                    </div>
                </section>
            </div>
        </div>


        <portal to="navButtons">

            <button class="checkout-button button button-fat fat-outline float-left"
                    @click="$router.push({name: 'page3'})">
                Tilbake
            </button>

            <button
                    class="checkout-button button button-fat float-right"
                    @click="submit"
                    :class="{disabled: !canGoToNextStep}">
                Bekreft bestilling og gå til betaling
            </button>
        </portal>


        <portal to="overviewButtons">
            <button
                    class="overview-button button button-fat w-100"
                    @click="submit"
                    :class="{disabled: !canGoToNextStep}">
                Bekreft bestilling og gå til betaling
            </button>
        </portal>


    </div>
</template>
<script>
import Radio from "../Radio";
import {mapGetters} from 'vuex'
import {required} from "vuelidate/src/validators";
import {mustBetrue} from "../validators";


export default {
    name: "Page4",
    components: {
        Radio,
    },
    validations: {
        agreedToTermsOfService: {
            required,
            mustBetrue
        }
    },
    computed: {
        selectedPaymentMethod: {
            get() {
                return this.$store.state.selectedPaymentMethod;
            },
            set(value) {
                this.$store.commit('updateSelectedPaymentMethod', value)
            }
        },
        agreedToTermsOfService: {
            get() {
                return this.$store.state.agreedToTermsOfService;
            },
            set(value) {
                this.$store.commit('updateAgreedToTermsOfService', value)
            }
        },
        agreedToMarketing: {
            get() {
                return this.$store.state.agreedToMarketing;
            },
            set(value) {
                this.$store.commit('updateAgreedToMarketing', value)
            }
        },
        ...mapGetters([
            "depositAmount"
        ]),

        canGoToNextStep: {
            cache: false,
            get() {
                if (this.$store.state.isReservingBooking) {
                    return false;
                }

                return this.$store.state.agreedToTermsOfService;
            }
        }
    },
    methods: {
        submit() {
            if (!this.canGoToNextStep) {
                this.$v.$touch();
                return false;
            }

            this.$store.dispatch('submitBooking')
        }
    }
};
</script>
<style scoped>
    .input-error {
        display: block;
        width: 100%;
        font-size: 14px;
        color: #FF0000;
    }

    .checkbox a {
        font-size: 16px;
    }

    .checkbox label:hover {
        color: #414141;
    }

</style>
